import { render } from "./FavoriteDocumentCard.vue?vue&type=template&id=699d3fe3&scoped=true"
import script from "./FavoriteDocumentCard.vue?vue&type=script&lang=js"
export * from "./FavoriteDocumentCard.vue?vue&type=script&lang=js"

import "./FavoriteDocumentCard.vue?vue&type=style&index=0&id=699d3fe3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699d3fe3"]])

export default __exports__